<div class="button-container" *ngIf="authService.hasPermission(['update'], 'PermissionController')">
  <p-button label="Sync Permissions" class="p-button-sm p-mb-10 button-right"
              icon="fa-solid fa-refresh" type="button" (click)="syncPermissions()"></p-button>
</div>
<p-tabView>
  <p-tabPanel header="Users" *ngIf="authService.hasPermission(['create', 'update'], 'UserController')">
    <app-users></app-users>
  </p-tabPanel>
  <p-tabPanel header="Roles" *ngIf="authService.hasPermission(['create', 'update'], 'RoleController')">
    <app-roles></app-roles>
  </p-tabPanel>
  <p-tabPanel header="Permissions" *ngIf="authService.hasPermission(['create', 'update'], 'PermissionController')">
    <app-permissions></app-permissions>
  </p-tabPanel>
  <p-tabPanel header="App API keys" *ngIf="authService.hasPermission(['read'], 'AppApiKeyController')">
    <app-app-api-keys></app-app-api-keys>
  </p-tabPanel>
  <p-tabPanel header="Teams" *ngIf="authService.hasPermission(['create', 'update'], 'UserController')">
    <app-teams></app-teams>
  </p-tabPanel>
</p-tabView>

<!-- Spinner -->
<ngx-spinner bdColor="rgba(36,34,36,0.8)" size="medium" color="#81c784" type="pacman">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<!-- Toast -->
<p-toast position="top-right"></p-toast>